/**
 * @module client/utils
 * @category utils
 */

/**
 * Converts a camelCase string to snake_case.
 *
 * This function takes a string in camelCase format and converts it to snake_case,
 * where each uppercase letter is preceded by an underscore. If the input string
 * already contains underscores, it will be returned unchanged.
 *
 * @memberof module:client/utils
 * @param {string} str - The input string in camelCase format.
 * @returns {string} The converted string in snake_case format.
 */
export const camelToSnakeCase = str => str.includes('_') ? str : str.split('').map((char) => char === char.toUpperCase() ? '_' + char.toLowerCase() : char).join('')
